import { useState } from "react";
import { useLoader } from "../context/LoaderContext";
import axios from "axios";
import { headers } from "../exports/exports";
import { dynamicSuccess, failed } from "../hooks/useToast";

const JoinCommunityOne = (props) => {
  const { joinCommunityHeaderData } = props;
  const { setLoading } = useLoader();
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [message, setMessage] = useState();
  const [errors, setErrors] = useState({});

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const validateStep = () => {
    let newErrors = {};
    if (!email) newErrors.email = "Email is required";
    else if (!isValidEmail(email)) newErrors.email = "Invalid email format";

    if (!name) newErrors.name = "Name is required";
    if (!phone) {
      newErrors.phone = "Phone Number is required";
    } else if (!/^\d{10}$/.test(phone)) {
      newErrors.phone = "Invalid Phone Number";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateStep()) {
      return;
    }
    setLoading(true);
    try {
      const data = {
        data: {
          Name: name,
          Email: email,
          Phone: String(phone),
          Message: message,
        },
      };
      axios
        .post(
          `${process.env.REACT_APP_strapiUrl}/api/ega-contact-messages`,
          data,
          {
            headers: headers,
          },
        )
        .then(() => {
          setLoading(false);
          dynamicSuccess("Form submitted successfully!");
          setName("");
          setEmail("");
          setPhone("");
          setMessage("");
          setErrors({});
        })
        .catch(() => {
          setLoading(false);
          failed();
        });
    } catch (e) {
      setLoading(false);
      failed();
    }
  };
  return (
    <section className="join-community" id="communityheader">
      <div className="container container--lg">
        <div className="bg-main-25 rounded-20 py-120 px-8">
          <div className="container">
            <div className="row gy-4 align-items-center">
              <div className="col-lg-6">
                <div className="join-community__content">
                  <div className="mb-40">
                    <h2 className="mb-24 wow bounceIn">
                      {joinCommunityHeaderData[0]?.title}
                    </h2>
                    <p className="text-neutral-500 text-line-2 wow bounceInUp">
                      {joinCommunityHeaderData[0]?.description}
                    </p>
                  </div>
                  <div className="p-24 bg-white rounded-12 box-shadow-md">
                    <div className="border border-neutral-30 rounded-8 bg-main-25 p-24">
                      <div>
                        <h4 className="mb-0">Get In Touch</h4>
                        <span className="d-block border border-neutral-30 my-24 border-dashed" />
                        <div className="mb-24">
                          <label
                            htmlFor="name"
                            className="text-neutral-700 text-lg fw-medium mb-12"
                          >
                            Name{" "}
                          </label>
                          <input
                            type="text"
                            className={`common-input rounded-pill border-transparent focus-border-main-600 ${
                              errors.name && "error-border"
                            }`}
                            id="name"
                            placeholder="Enter Name..."
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                          {errors.name && (
                            <p className="error-message">{errors.name}</p>
                          )}
                        </div>
                        <div className="mb-24">
                          <label
                            htmlFor="email"
                            className="text-neutral-700 text-lg fw-medium mb-12"
                          >
                            Email{" "}
                          </label>
                          <input
                            type="email"
                            className={`common-input rounded-pill border-transparent focus-border-main-600 ${
                              errors.email && "error-border"
                            }`}
                            id="email"
                            placeholder="Enter Email..."
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          {errors.email && (
                            <p className="error-message">{errors.email}</p>
                          )}
                        </div>
                        <div className="mb-24">
                          <label
                            htmlFor="phone"
                            className="text-neutral-700 text-lg fw-medium mb-12"
                          >
                            Phone{" "}
                          </label>
                          <input
                            type="number"
                            className={`common-input rounded-pill border-transparent focus-border-main-600 ${
                              errors.phone && "error-border"
                            }`}
                            id="phone"
                            placeholder="Enter Your Number..."
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                          />
                          {errors.phone && (
                            <p className="error-message">{errors.phone}</p>
                          )}
                        </div>
                        <div className="mb-24">
                          <label
                            htmlFor="desc"
                            className="text-neutral-700 text-lg fw-medium mb-12"
                          >
                            Message
                          </label>
                          <textarea
                            id="desc"
                            className={`common-input rounded-24 border-transparent focus-border-main-600 h-110 ${
                              errors.message && "error-border"
                            }`}
                            placeholder="Enter Your Message..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                          />
                          {errors.message && (
                            <p className="error-message">{errors.message}</p>
                          )}
                        </div>
                        <div className="mb-0">
                          <button
                            type="submit"
                            className="btn btn-main rounded-pill flex-center gap-8 mt-40"
                            onClick={() => {
                              handleSubmit();
                            }}
                          >
                            Send Message
                            <i className="ph-bold ph-arrow-up-right d-flex text-lg" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="join-community__thumb text-end position-relative">
                  <img
                    src={
                      joinCommunityHeaderData[0]?.image[0]?.media?.url &&
                      `${process.env.REACT_APP_cmsUrl}${joinCommunityHeaderData[0]?.image[0]?.media?.url}`
                    }
                    alt="join-community-img"
                    className="wow bounceIn"
                    data-tilt=""
                    data-tilt-max={12}
                    data-tilt-speed={500}
                    data-tilt-perspective={5000}
                    data-tilt-full-page-listening=""
                  />
                  {/* <div className="offer-message style-two px-24 py-12 rounded-12 bg-white fw-medium flex-align d-inline-flex gap-16 box-shadow-lg animation-upDown">
                    <span className="banner-box__icon flex-shrink-0 w-48 h-48 bg-purple-400 text-white text-2xl flex-center rounded-circle">
                      <i className="ph-bold ph-users" />
                    </span>
                    <div className="text-start">
                      <h6 className="mb-4">56K</h6>
                      <span className="">All Students</span>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinCommunityOne;
